import {
  validateRequest,
  validateResponseStatus
} from "./chunk-TYKHD5VE.mjs";
import {
  __decorateClass
} from "./chunk-AYNJNFEN.mjs";

// src/utils/utils.ts
import Buffer from "buffer/";
import axios from "axios";
function urlEncodeBase64(str) {
  const b64Chars = { "+": "-", "/": "_", "=": "" };
  return str.replace(/[+/=]/g, (m) => b64Chars[m] ?? "");
}
function encodeState(state) {
  return Buffer.Buffer.from(JSON.stringify(state)).toString("base64");
}
var RequestBuilder = class {
  async get(requestUrl, options = {}) {
    return this.ValidateHTTPResponse(
      await axios.get(requestUrl, options)
    );
  }
  async post(requestUrl, data, options = {}) {
    return this.ValidateHTTPResponse(
      await axios.post(requestUrl, data, options)
    );
  }
  ValidateHTTPResponse(HTTPRawResponse) {
    return Promise.resolve(HTTPRawResponse.data);
  }
};
__decorateClass([
  validateRequest
], RequestBuilder.prototype, "get", 1);
__decorateClass([
  validateRequest
], RequestBuilder.prototype, "post", 1);
__decorateClass([
  validateResponseStatus
], RequestBuilder.prototype, "ValidateHTTPResponse", 1);

export {
  urlEncodeBase64,
  encodeState,
  RequestBuilder
};
